import * as React from "react";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import { Paper as MuiPaper, InputBase, IconButton } from "@mui/material";

// Styled Paper (container)
const Paper = styled(MuiPaper)`
  padding: 15px 18px;
  display: flex;
  align-items: center;
  width: 150px;
  height: 50px;
  border-radius: 30px;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`;

// Styled Input
const StyledInput = styled(InputBase)`
  width: 100%;
  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    opacity: 0.4;
  }
`;

// Styled IconButton
const StyledIconButton = styled(IconButton)`
  padding: 10px;
`;

export default function Search({ handleSearchDebounce, setPage }) {
  return (
    <Paper elevation={0}>
      <StyledInput
        placeholder="Search"
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            opacity: 0.4,
            mixBlendMode: "normal",
          },
        }}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
          setPage(1);
          handleSearchDebounce(e.target.value);
        }}
      />
      <StyledIconButton aria-label="search">
        <SearchIcon style={{ color: "#231F20" }} />
      </StyledIconButton>
    </Paper>
  );
}
